import { InjectionToken } from '@angular/core';

export interface PnpConfig {
  microAppId: string;
  xhrPrefix: string;
  shouldInjectToken: boolean;
}

export const configToken = new InjectionToken('pnpConfig');
